import { ChangeEventHandler, VFC } from "react";
import { DateDataField } from "src/types/data-field.types";
import { NodeData } from "src/types/node.types";
import { FormField } from "../form-field";
import { Input } from "./input";

export interface DateFieldProps {
  field: DateDataField;
  data: NodeData;
  onChange: (data: NodeData) => void;
}

export const DateField: VFC<DateFieldProps> = (props) => {
  const key = props.field.key;
  const onChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const dateStr = e.target.value;
    const date = dateStr ? new Date(dateStr) : undefined;
    props.onChange({ ...props.data, [key]: date });
  };

  const value = props.data[key] as Date;
  const dateStr = value ? dateToDateString(value) : undefined;

  return (
    <FormField.Field>
      <FormField.Label>{props.field.label}</FormField.Label>
      <FormField.Input>
        <Input type="date" value={dateStr} onChange={onChange} />
      </FormField.Input>
    </FormField.Field>
  );
};

function dateToDateString(date: Date) {
  const offset = date.getTimezoneOffset();
  date = new Date(date.getTime() - offset * 60 * 1000);
  return date.toISOString().split("T")[0];
}
